module.exports = __webpack_public_path__ + "img/21_27.f6ca4c3d.png";